module.exports = __webpack_public_path__ + "img/selected7-min.ea3a8634.png";